import {runtime} from "./utils-js";

let Windows = new Map()
let Linux = new Map()
let Darwin = new Map()

Windows.set("nextTab", ["ctrl+ArrowDown", "ctrl+Tab"])
Darwin.set("nextTab", ["ctrl+ArrowDown", "ctrl+Tab"])
Linux.set("nextTab", ["ctrl+ArrowDown", "ctrl+Tab"])

Windows.set("prevTab", ["ctrl+ArrowUp", "ctrl+shift+Tab"])
Darwin.set("prevTab", ["ctrl+ArrowUp", "ctrl+shift+Tab"])
Linux.set("prevTab", ["ctrl+ArrowUp", "ctrl+shift+Tab"])

Windows.set("showSessions", ["alt+o", "ctrl+o"])
Darwin.set("showSessions", ["alt+o", "ctrl+o"])
Linux.set("showSessions", ["alt+o", "ctrl+o"])

Windows.set("newSession", ["alt+n", "ctrl+n"])
Darwin.set("newSession", ["alt+n", "ctrl+n"])
Linux.set("newSession", ["alt+n", "ctrl+n"])

Windows.set("dupCurSession", ["ctrl+alt+c"])
Darwin.set("dupCurSession", ["ctrl+alt+c"])
Linux.set("dupCurSession", ["ctrl+alt+c"])

Windows.set("newLocalSession", ["ctrl+alt+l"])
Darwin.set("newLocalSession", ["ctrl+alt+l"])
Linux.set("newLocalSession", ["ctrl+alt+l"])

Windows.set("closeCurSession", ["ctrl+shift+F4"])
Darwin.set("closeCurSession", ["ctrl+shift+F4"])
Linux.set("closeCurSession", ["ctrl+shift+F4"])

Windows.set("toggleSessFullscreen", ["alt+F11"])
Darwin.set("toggleSessFullscreen", ["alt+F11"])
Linux.set("toggleSessFullscreen", ["alt+F11"])

// terminal 下和 VIM 的 redo 快捷键冲突
// Windows.set("reload", ["ctrl+r"])
// Darwin.set("reload", ["meta+r"])
// Linux.set("reload", ["ctrl+r"])

Windows.set("forceReload", ["ctrl+shift+R"])
Darwin.set("forceReload", ["meta+shift+r"])
Linux.set("forceReload", ["ctrl+shift+R"])

Windows.set("devMode", ["ctrl+shift+I"])
Darwin.set("devMode", ["meta+alt+i"])
Linux.set("devMode", ["ctrl+shift+I"])

Windows.set("actualSize", ["ctrl+0"])
Darwin.set("actualSize", ["meta+0"])
Linux.set("actualSize", ["ctrl+0"])

Windows.set("zoomIn", ["ctrl+shift+'+'"])
Darwin.set("zoomIn", ["meta+'+'"])
Linux.set("zoomIn", ["ctrl+shift+'+'"])

Windows.set("zoomOut", ["ctrl+'-'"])
Darwin.set("zoomOut", ["meta+'-'"])
Linux.set("zoomOut", ["ctrl+'-'"])

Windows.set("toggleFullscreen", ["F11"])
Darwin.set("toggleFullscreen", ["meta+ctrl+f"])
Linux.set("toggleFullscreen", ["F11"])

Windows.set("undo", ["ctrl+z"])
Darwin.set("undo", ["meta+z"])
Linux.set("undo", ["ctrl+z"])

Windows.set("redo", ["ctrl+y"])
Darwin.set("redo", ["meta+shift+z"])
Linux.set("redo", ["ctrl+y"])

Windows.set("cut", ["ctrl+x"])
Darwin.set("cut", ["meta+x"])
Linux.set("cut", ["ctrl+x"])

Windows.set("copy", ["ctrl+c"])
Darwin.set("copy", ["meta+c"])
Linux.set("copy", ["ctrl+c"])

Windows.set("paste", ["ctrl+v"])
Darwin.set("paste", ["meta+v"])
Linux.set("paste", ["ctrl+v"])

Windows.set("selectAll", ["ctrl+a"])
Darwin.set("selectAll", ["meta+a"])
Linux.set("selectAll", ["ctrl+a"])

Windows.set("termSearch", ["ctrl+alt+f"])
Darwin.set("termSearch", ["ctrl+alt+f"])
Linux.set("termSearch", ["meta+alt+f"])

Windows.set("termVimMode", ["ctrl+alt+v"])
Darwin.set("termVimMode", ["ctrl+alt+v"])
Linux.set("termVimMode", ["meta+alt+v"])

Windows.set("guide", ["alt+g", "ctrl+g"])
Darwin.set("guide", ["alt+g", "ctrl+g"])
Linux.set("guide", ["alt+g", "ctrl+g"])

Windows.set("settings", ["alt+,", "ctrl+,"])
Darwin.set("settings", ["alt+,", "ctrl+,"])
Linux.set("settings", ["alt+,", "ctrl+,"])

// 无法识别 ctrl+w+h 和 ctrl+h 的区别，导致 vim 下的多窗口模式无法切换
// Windows.set("showSSHTrustedHosts", ["alt+h", "ctrl+h"])
// Darwin.set("showSSHTrustedHosts", ["alt+h", "ctrl+h"])
// Linux.set("showSSHTrustedHosts", ["alt+h", "ctrl+h"])

// 无法识别 ctrl+w+h 和 ctrl+h 的区别，导致 vim 下的多窗口模式无法切换
// Windows.set("showSSHKeys", ["alt+k", "ctrl+k"])
// Darwin.set("showSSHKeys", ["alt+k", "ctrl+k"])
// Linux.set("showSSHKeys", ["alt+k", "ctrl+k"])

Windows.set("minimizeWin", ["ctrl+m"])
Darwin.set("minimizeWin", ["meta+m"])
Linux.set("minimizeWin", ["ctrl+m"])

// CTRL+W 关闭窗口快捷键和命令行删除最后一个单词的快捷键冲突
// Windows.set("closeWin", ["ctrl+w"])
// Darwin.set("closeWin", ["meta+w"])
// Linux.set("closeWin", ["ctrl+w"])

function getCombosMap() {
    switch (runtime.os) {
        case runtime.osWindows:
            return Windows
        case runtime.osDarwin:
            return Darwin
        case runtime.osLinux:
            return Linux
    }
    return null
}

export default {
    getCombosMap,
}
